import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {Layout} from '@docma-mm-core/layout/layout';
import {LayoutFieldExt} from '@docma-mm-core/layout/layout-field';
import {LayoutEditFieldsService} from '../services/layout-edit-fields.service';
import {ColDef, GetRowIdParams, GridApi, IRowDragItem, RowDragEvent, } from 'ag-grid-community';
import {LayoutFieldCellRendererComponent} from './layout-field-cell-renderer/layout-field-cell-renderer.component';
import {AgGridAngular} from 'ag-grid-angular';
import {CellValueChangedEvent} from 'ag-grid-community/dist/lib/main';
import {SearchOptions} from '@mydocma/component-library/src/lib/search/options/search-options';
import {SearchFilterService} from '@mydocma/component-library/src/lib/search';
import {FilterableDataSource} from '@mydocma/component-library/src/lib/search/filterable-data-source';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {BehaviorSubject, Subject} from 'rxjs';
import {LayoutFilter} from '@docma-mm-core/layout/layout-filter';
import {PersonalizationService} from '@mydocma/app-container';
import {PersonalizationKeysEnum} from '@docma-mm-core/personalization/personalization-keys.enum';
import {User} from '@docma-mm-core/user/user';
import {Project} from '@docma-mm-core/project/project';
import {ITooltipParams} from 'ag-grid-community/dist/lib/rendering/tooltipComponent';
import {TranslateService} from '@ngx-translate/core';
import {MydocmaGridOptions} from '@mydocma/component-library/src/lib/grid';
import {colTypeMinWidth} from '../../../../mm-faults/mm-faults-ag-grid/col-defs/field-defaults';

@UntilDestroy()
@Component({
  selector: 'mydocma-mm-layout-edit-fields',
  templateUrl: './layout-edit-fields.component.html',
  styleUrls: ['./layout-edit-fields.component.scss'],
  providers: [LayoutEditFieldsService]
})
export class LayoutEditFieldsComponent implements OnInit {

  constructor(public readonly fieldsService: LayoutEditFieldsService,
              private readonly personalizationService: PersonalizationService,
              private readonly transalteService: TranslateService) {

    this.personalizationService.getValue(PersonalizationKeysEnum.CurrentLayoutDisplayField)
      .then(value => {
        switch (value){
          case '1':
            this.currentFieldDisplayColumnsSubject.next(FieldDisplayColumnEnum.Global);
            this.setScope(FieldDisplayColumnEnum.Global);
            break;
          case '2':
            this.currentFieldDisplayColumnsSubject.next(FieldDisplayColumnEnum.Project);
            this.setScope(FieldDisplayColumnEnum.Project);
            break;
          case '4':
            this.currentFieldDisplayColumnsSubject.next(FieldDisplayColumnEnum.Prop);
            this.setScope(FieldDisplayColumnEnum.Prop);
            break;
          default:
            this.currentFieldDisplayColumnsSubject.next(FieldDisplayColumnEnum.Project);
            this.setScope(FieldDisplayColumnEnum.Project);
            break;
        }
      });

    this.searchOptions = {
      allowMultipleFilter: true,
      onReady: (searchFilterService: SearchFilterService) => {
        searchFilterService.dataSource = { data: [], doesItemPassFilter:  (item: any, filters: string[]) => true } as FilterableDataSource;
        searchFilterService.filters$
          .subscribe((filters: string[]) => {
            this.searchFilters = filters.filter(x => x != null && x != '').map(x => x.toLowerCase());
            if (this.gridApi) {
              this.setDataSource();
            }
          });
      },
    };

    this.gridOptions = {
      rowSelection: 'single',
      suppressRowClickSelection: true,
      context: { componentParent: this },
      rowDragManaged: false,
      animateRows: true,
      enableFillHandle: true,
      rowDragMultiRow: false,
      rowDragEntireRow: false,
      headerHeight: 0,
      suppressLoadingOverlay: true,
      columnDefs: [
        {
          colId: 'IsAssigned',
          resizable: false,
          pinned: false,
          suppressAutoSize: false,
          suppressSizeToFit: true,
          suppressMovable: true,
          field: 'IsAssigned',
          headerName: '',
          cellRenderer: LayoutFieldCellRendererComponent,
          rowDrag: (params) => {
            const lf: LayoutFieldExt = params.node.data;
            return (lf.IsAssigned);
          },
          rowDragText: (params: IRowDragItem, dragItemCount: number) => {
            const lf: LayoutFieldExt = params.rowNode.data;
            return (this.currentFieldDisplayColumnsSubject.value === FieldDisplayColumnEnum.Global ? lf.FieldMinimal.Global
              : (this.currentFieldDisplayColumnsSubject.value === FieldDisplayColumnEnum.Project ? lf.FieldMinimal.Project
                : lf.FieldMinimal.Prop));
          },
          width: 100
        },
        {
          colId: 'Global',
          resizable: false,
          pinned: false,
          suppressAutoSize: false,
          suppressSizeToFit: false,
          suppressMovable: true,
          field: 'FieldMinimal.Global',
          headerName: 'Global name',
          tooltipValueGetter: (params: ITooltipParams) => {
            const lf: LayoutFieldExt = params.data;
            return (lf.HasPermission ? null : this.transalteService.instant('MM.layout.noFieldPermission'));
          }
        },
        // {
        //   colId: 'HasPermission',
        //   resizable: false,
        //   pinned: false,
        //   suppressAutoSize: false,
        //   suppressSizeToFit: false,
        //   suppressMovable: true,
        //   field: 'HasPermission',
        //   headerName: 'Perm',
        //   width: 80,
        //   tooltipValueGetter: (params: ITooltipParams) => {
        //     const lf: LayoutFieldExt = params.data;
        //     return (lf.HasPermission ? null : this.transalteService.instant('MM.layout.noFieldPermission'))
        //   }
        // },
        {
          colId: 'Project',
          resizable: true,
          pinned: false,
          suppressAutoSize: false,
          suppressSizeToFit: false,
          suppressMovable: true,
          field: 'FieldMinimal.Project',
          headerName: 'Project name',
          hide: true,
          tooltipValueGetter: (params: ITooltipParams) => {
            const lf: LayoutFieldExt = params.data;
            return (lf.HasPermission ? null : this.transalteService.instant('MM.layout.noFieldPermission'));
          }
        },
        {
          colId: 'Prop',
          resizable: true,
          pinned: false,
          suppressAutoSize: false,
          suppressSizeToFit: false,
          suppressMovable: true,
          field: 'FieldMinimal.Prop',
          headerName: 'Default name',
          hide: true,
          tooltipValueGetter: (params: ITooltipParams) => {
            const lf: LayoutFieldExt = params.data;
            return (lf.HasPermission ? null : this.transalteService.instant('MM.layout.noFieldPermission'));
          }
        }
      ],
      getRowId: (params: GetRowIdParams) => {
        return params.data.LayoutField.Id;
      },
      rowClassRules: {
        'field-row-permitted': params => params.data.HasPermission === true,
        'field-row-not-permitted': params => params.data.HasPermission === false,
      },

      onGridReady: (params) => {
        this.gridApi = params.api;

        this.setDataSource();
      },
      onRowDragEnd: (event: RowDragEvent) => {
        this.commit();
      },
      onRowDragMove: (event: RowDragEvent) => {
        if (!event.overNode?.data){
          return;
        }

        const draggedLayoutField: LayoutFieldExt = event.node.data;
        const targetLayoutField: LayoutFieldExt = event.overNode.data;

        const maxIndex = this.fields.filter(x => x.LayoutField.SortId != null).length;
        let sortChanged = false;

        if (event.overIndex > maxIndex) {
          // console.log('onRowDragMove ##CANCEL!##');
        }
        else {
          let fromIndex = event.node.rowIndex;
          let toIndex = event.overIndex;

          if (fromIndex !== toIndex) {
            let fromIndexLf = this.fields.indexOf(draggedLayoutField);
            let toIndexLf = this.fields.indexOf(targetLayoutField);

            // move by indexes
            moveInArray(this.fields, fromIndexLf, toIndexLf);

            // re-calculate SortId
            const fieldsInternal = this.fields.filter(x => x.IsAssigned);
            for (let i = 0; i < fieldsInternal.length; i++) {
              if (fieldsInternal[i].LayoutField.SortId != i) {
                fieldsInternal[i].LayoutField.SortId = i;
                sortChanged = true;
              }
            }

            if (sortChanged) {
              // console.log('NEW SORT IDS ' + [...this.fields.filter(x => x.IsAssigned).map(f => `${f.LayoutField.SortId} ${f.FieldMinimal.Prop}`)].join(', '));
              this.setDataSource();
            }
          }
        }
      },
      onCellValueChanged: (event: CellValueChangedEvent) => {
        const lf: LayoutFieldExt = event.node.data;

        // IsAssigned toggled
        if (event.column.getColId() === 'IsAssigned') {
          if (lf.IsAssigned) {
            let maxSortId = Math.max(...this.fields.filter(x => x.LayoutField.SortId != null).map(f => f.LayoutField.SortId));
            maxSortId = (maxSortId === -Infinity ? -1 : maxSortId);
            const newSortId = maxSortId + 1;
            lf.LayoutField.SortId = newSortId;
          }
          else {
            lf.LayoutField.SortId = 0;
          }
          this.setDataSource();
          this.commit();
        }
      },
      components: { layoutCellRenderer: LayoutFieldCellRendererComponent }
    } as MydocmaGridOptions;
  }

  @ViewChild('grid') grid: AgGridAngular;

  @Input()
  editArgs?: {Layout: Layout, Fields: LayoutFieldExt[], Filters: LayoutFilter[], IsNew: boolean, project: Project, user: User};
  fields: LayoutFieldExt[];

  currentFieldsSubject = new BehaviorSubject<LayoutFieldExt[]>([]);
  isAssignedAllSubject = new BehaviorSubject<boolean>(false);
  isAssignedAll$ = this.isAssignedAllSubject.asObservable();

  valueChanged = new Subject();

  private gridApi: GridApi;

  gridOptions: MydocmaGridOptions;
  searchOptions: SearchOptions;

  searchFilters: string[] = [];

  fieldDisplayColumns = FieldDisplayColumnEnum;
  currentFieldDisplayColumnsSubject = new BehaviorSubject<FieldDisplayColumnEnum>(FieldDisplayColumnEnum.Project);
  currentFieldDisplayColumns$ = this.currentFieldDisplayColumnsSubject.asObservable();

  initialize(editArgs?: {Layout: Layout, Fields: LayoutFieldExt[], Filters: LayoutFilter[], IsNew: boolean, project: Project, user: User}) {
    this.editArgs = editArgs;
    this.setFields(JSON.parse(JSON.stringify(this.editArgs.Fields)));
    this.setDataSource();
  }

  onShow() {
    this.gridOptions.api.sizeColumnsToFit();
  }

  setFields(fields: LayoutFieldExt[]) {
    this.fields = fields.sort((x, y) =>
      (y.IsAssigned ? 1 : 0) - (x.IsAssigned ? 1 : 0)
      || (x.LayoutField?.SortId ?? 0) - (y.LayoutField?.SortId ?? 0)
      || (this.currentFieldDisplayColumnsSubject.value === FieldDisplayColumnEnum.Global ? x.FieldMinimal.Global.localeCompare(y.FieldMinimal.Global) : 0)
      || (this.currentFieldDisplayColumnsSubject.value === FieldDisplayColumnEnum.Project ? x.FieldMinimal.Project.localeCompare(y.FieldMinimal.Project) : 0)
      || (this.currentFieldDisplayColumnsSubject.value === FieldDisplayColumnEnum.Prop ? x.FieldMinimal.Prop.localeCompare(y.FieldMinimal.Prop) : 0)
    );
  }

  setDataSource() {
    if (!this.fields) {
      return;
    }

    const sortedFields = [...this.fields].filter(x =>
      this.searchFilters.length === 0
      || (this.searchFilters.some(fil => x.FieldMinimal.Global.toLowerCase().includes(fil)) && this.currentFieldDisplayColumnsSubject.value === FieldDisplayColumnEnum.Global)
      || (this.searchFilters.some(fil => x.FieldMinimal.Project.toLowerCase().includes(fil)) && this.currentFieldDisplayColumnsSubject.value === FieldDisplayColumnEnum.Project)
      || (this.searchFilters.some(fil => x.FieldMinimal.Prop.toLowerCase().includes(fil)) && this.currentFieldDisplayColumnsSubject.value === FieldDisplayColumnEnum.Prop)

    ).sort((x, y) =>
      (y.IsAssigned ? 1 : 0) - (x.IsAssigned ? 1 : 0)
      || (x.LayoutField?.SortId ?? 0) - (y.LayoutField?.SortId ?? 0)
      || (this.currentFieldDisplayColumnsSubject.value === FieldDisplayColumnEnum.Global ? x.FieldMinimal.Global.localeCompare(y.FieldMinimal.Global) : 0)
      || (this.currentFieldDisplayColumnsSubject.value === FieldDisplayColumnEnum.Project ? x.FieldMinimal.Project.localeCompare(y.FieldMinimal.Project) : 0)
      || (this.currentFieldDisplayColumnsSubject.value === FieldDisplayColumnEnum.Prop ? x.FieldMinimal.Prop.localeCompare(y.FieldMinimal.Prop) : 0)
    );

    this.gridOptions.api.setRowData(sortedFields);
    this.gridOptions.api.clearFocusedCell();
    this.gridOptions.api.sizeColumnsToFit();

    this.currentFieldsSubject.next(sortedFields);
  }

  private commit() {
    let hasChanges = false;

    for (const f of this.editArgs.Fields) {
      const _f = this.fields.find(x => x.LayoutField.Field.Id === f.LayoutField.Field.Id);
      if (f.LayoutField.SortId !== _f.LayoutField.SortId) {
        f.LayoutField.SortId = _f.LayoutField.SortId;
        hasChanges = true;
      }
      if (f.IsAssigned !== _f.IsAssigned) {
        const lfIdx = this.editArgs.Layout.LayoutFields.findIndex(lf => lf.Field.Id === f.LayoutField.Field.Id);
        if (lfIdx === -1 && _f.IsAssigned) {
          if (!f.LayoutField.Width){
            f.LayoutField.Width = colTypeMinWidth[f.LayoutField.Field.DataType] * 10;
          }
          this.editArgs.Layout.LayoutFields.push(f.LayoutField);
        }
        else if (lfIdx !== -1 && !_f.IsAssigned) {
          this.editArgs.Layout.LayoutFields.splice(lfIdx, 1);
        }
        f.IsAssigned = _f.IsAssigned;
        hasChanges = true;
      }
    }

    if (hasChanges) {
      this.valueChanged.next(null);
    }
  }

  ngOnInit(): void {
    this.currentFieldsSubject
      .pipe(untilDestroyed(this))
      .subscribe(currentFields =>  {
        if (currentFields.length > 0 && currentFields.every(x => x.IsAssigned)) {
          this.isAssignedAllSubject.next(true);
        }
        else {
          this.isAssignedAllSubject.next(false);
        }
      });
  }

  onActiveAllToggled() {
    this.isAssignedAllSubject.next(!this.isAssignedAllSubject.value);
    let newSortId: number;
    let hasChanges = false;

    if (this.isAssignedAllSubject.value) {
      newSortId = Math.max(...this.fields.filter(x => x.LayoutField?.SortId).map(f => +f.LayoutField.SortId)) + 1;
      if (newSortId === -Infinity) {
        newSortId = 0;
      }
    }
    else {
      newSortId = 0;
    }

    this.currentFieldsSubject.value.forEach(f => {
      let _f = this.fields.find(x => x.LayoutField.Field.Id === f.LayoutField.Field.Id);
      if (_f) {
        _f.IsAssigned = this.isAssignedAllSubject.value;
        _f.LayoutField.SortId = (this.isAssignedAllSubject.value ? newSortId : 0);
        newSortId++;
        hasChanges = true;
      }
    });

    if (hasChanges) {
      this.gridApi.redrawRows();
      this.commit();
    }
  }

  onScopeClick(scope: FieldDisplayColumnEnum) {
    this.currentFieldDisplayColumnsSubject.next(scope);
    this.setFields(this.fields);
    this.setDataSource();
    this.setScope(scope);

    this.personalizationService.setValue(PersonalizationKeysEnum.CurrentLayoutDisplayField, scope.toString());
  }

  setScope(scope: FieldDisplayColumnEnum) {
    const globalCol: ColDef = this.gridOptions.columnDefs.find((x: ColDef) => x.colId === 'Global');
    const projectCol: ColDef = this.gridOptions.columnDefs.find((x: ColDef) => x.colId === 'Project');
    const propCol: ColDef = this.gridOptions.columnDefs.find((x: ColDef) => x.colId === 'Prop');
    if (scope === FieldDisplayColumnEnum.Global) {
      globalCol.hide = false;
      projectCol.hide = true;
      propCol.hide = true;
    }
    else if (scope === FieldDisplayColumnEnum.Project) {
      globalCol.hide = true;
      projectCol.hide = false;
      propCol.hide = true;
    }
    else if (scope === FieldDisplayColumnEnum.Prop) {
      globalCol.hide = true;
      projectCol.hide = true;
      propCol.hide = false;
    }

    this.gridApi.setColumnDefs(this.gridOptions.columnDefs);
    this.gridOptions.api.sizeColumnsToFit();
  }
}

export enum FieldDisplayColumnEnum {
  Global = 1,
  Project = 2,
  Prop = 4
}

function moveInArray(arr: any[], fromIndex: number, toIndex: number) {
  let element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
}
